

































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import AddOrEdit from './parts/addOrEdit.vue'
import {DeleteMedDoc, GetMedDocs} from "@/api/hd"

@Component({
	components:{AddOrEdit}
})
export default class MedDocs extends AbpBase {
	@Prop() patient:any
	imgSrc = ""
	url = XMLHTTP_BASEURL
	imgVisible = false
	data:any = []
	addShow = false
	addData:any = {}
	created(){
		this.init()
	}
	showImg(img:any){
		this.imgSrc = img
		this.imgVisible = true

	}
	addOne(){
		this.addData = {
			mode: 'add',
			patient: this.patient
		}
		this.addShow = true
	}
	editOne(item:any){
		this.addData = {
			mode: 'edit',
			patient: this.patient,
			data:item
		}
		this.addShow = true
	}
	async deleteOne(item:any){
		let res = await DeleteMedDoc({
			Id: item.id
		})
		if (res.status === 1) {
			this.init()
		}
	}
	addClose(){
		this.addShow = false
	}
	saveSuccess(){
		this.addShow = false
		this.init()
	}
	async init(){
		let res = await GetMedDocs({PatientId:this.patient.id})
		if (res.status === 1){
			let data:any = []
			res.objects.forEach((item:any) => {
				let photoAddress = item.photoAddress.split(";")
				let pics:any = []
				photoAddress.forEach((photo:any) => {
					pics.push(this.url + photo)
				})
				item.pics = pics
				data.push(item)
			})
			this.data = data
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/medDocs/index.vue